const moment = require('moment');
const HOLIDAY_FORMAT = 'YYYY-MM-DD';

//Format: MM-DD
const staticHolidays = [
  '01-01', //Dia Mundial da Paz
  '04-21', //Tiradentes
  '05-01', //Dia do Trabalho
  '09-07', //Independência do Brasil
  '10-12', //Nossa Srª Aparecida
  '11-02', //Finados
  '11-15', //Proclamação da República
  '11-20', //Dia da consciência negra
  '12-25' //Natal
];

const getFixedHolidays = year => {
  return staticHolidays.map(monthDay => {
    return `${year}-${monthDay}`;
  });
};

const padDate = num => {
  const s = '0' + num;
  return s.slice(-2);
};

// https://www.inf.ufrgs.br/~cabral/Pascoa.html
const getEasterDate = year => {
  const c = Math.floor(year / 100);
  const n = year - 19 * Math.floor(year / 19);
  const k = Math.floor((c - 17) / 25);
  let i = c - Math.floor(c / 4) - Math.floor((c - k) / 3) + 19 * n + 15;
  i = i - 30 * Math.floor(i / 30);
  i = i - Math.floor(i / 28) * (1 - Math.floor(1 / 28) * Math.floor(29 / (i + 1)) * Math.floor((21 - n) / 11));
  let j = year + Math.floor(year / 4) + i + 2 - c + Math.floor(c / 4);
  j = j - 7 * Math.floor(j / 7);
  const l = i - j;
  const m = padDate(Math.floor(3 + Math.floor((l + 40) / 44)));
  const d = padDate(Math.floor(l + 28 - 31 * Math.floor(m / 4)));

  return moment(`${year}-${m}-${d}`, HOLIDAY_FORMAT);
};

const getLunarHolidays = year => {
  const EasterDate = getEasterDate(year);

  const lunarHolidays = [];
  lunarHolidays.push(EasterDate.clone().subtract(47, 'day').format(HOLIDAY_FORMAT)); //Segunda-feira de Carnaval
  lunarHolidays.push(EasterDate.clone().subtract(48, 'day').format(HOLIDAY_FORMAT)); //Terça-feira de Carnaval
  lunarHolidays.push(EasterDate.clone().subtract(2, 'day').format(HOLIDAY_FORMAT)); //Sexta-Feira da Paixão
  lunarHolidays.push(EasterDate.clone().add(60, 'day').format(HOLIDAY_FORMAT)); //Corpus Christi

  return lunarHolidays;
};

module.exports = year => {
  const fixedHolidays = getFixedHolidays(year);
  const lunarHolidays = getLunarHolidays(year);

  return [...fixedHolidays, ...lunarHolidays];
};
